module.exports = "<div class=\"container container-webcam\">\r\n  <div #canvas></div>\r\n  <footer>\r\n    <button type=\"button\" class=\"m-btn m-btn-primary m-btn-block\" (click)=\"capture()\">Capture</button>\r\n  </footer>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/web-cam/web-cam.component.html
// module id = 2358
// module chunks = 66